import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { UiButtonComponent } from '@vasta/frontend-ui-buttons';

@Component({
  selector: 'ui-header',
  imports: [UiButtonComponent],
  standalone: true,
  templateUrl: './ui-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiHeaderComponent {
  showToggle = input<boolean>(false);
  readonly toggleMenu = output<void>();

  onToggleMenu() {
    this.toggleMenu.emit();
  }
}
